import VueRouter from 'vue-router'
import store from '@/store'
import auth from '@/middleware/auth'
import middlewarePipeline from '@/middleware/pipeline'

import HelloWorld from "@/components/HelloWorld";
import PageNotFound from "@/components/NotFound/PageNotFound";
import IndexDashboard from "@/components/Dashboard/Index"
import LoginFormIndex from '@/components/LoginForm/Index';
import RegisterFormIndex from '@/components/RegisterForm/Index';

const router = new VueRouter({
    mode: 'history',
    base: __dirname,
    routes: [
        {
            path: '/',
            name: 'dashboard',
            component: IndexDashboard,
            meta: {
                middleware: [
                    auth
                ]
            },
        },
        {
            path: '/home',
            name: 'home',
            component: HelloWorld,
            meta: {
                middleware: [
                    auth
                ]
            },
        },
        {
            path: '/login',
            name: 'login',
            component: LoginFormIndex
        },
        {
            path: '/register',
            name: 'register',
            component: RegisterFormIndex,
        },
        {path: "*", component: PageNotFound}
    ],
});

router.beforeEach((to, from, next) => {
    if (!to.meta.middleware) {
        return next()
    }
    const middleware = to.meta.middleware
    const context = {
        to,
        from,
        next,
        store
    }
    return middleware[0]({
        ...context,
        next: middlewarePipeline(context, middleware, 1)
    })
})

export default router